module.exports = __webpack_public_path__ + "static/media/indvstry-webapp-poster.2375e86b.jpg";